// frontend/src/lib/paymentBasis.js
// P3-views: invoice paymentBasis ('ambassador'|'ad_hoc') → RU label + chip colors.
// Single source so the list view and the contract card render identically.
export const PAYMENT_BASIS_LABEL = {
  ambassador: 'По амбассадору',
  ad_hoc: 'Разовое размещение',
  direct: 'Прямая выплата',
};

export const PAYMENT_BASIS_CHIP = {
  ambassador: { background: '#ccfbf1', color: '#0f766e' },
  ad_hoc:     { background: '#fae8ff', color: '#86198f' },
  direct:     { background: '#ffedd5', color: '#9a3412' },
};

export function paymentBasisLabel(v) {
  return PAYMENT_BASIS_LABEL[v] || '—';
}

// Тип договора (placementType) ↔ ось paymentBasis. Onetime-размещение = ad_hoc,
// постоянный (recurring) = по амбассадору. Undefined/legacy → ambassador.
export function placementToBasis(placementType) {
  return placementType === 'onetime' ? 'ad_hoc' : 'ambassador';
}

// Тип оплаты для формы прямой выплаты — по статусу лида. Зеркалит backend
// deriveInvoiceKind (invoiceService.js): тест-статусы → «Тестовый», иначе «По амбассадору».
// Display-only; на записанный kind (снапшот на бэке) не влияет.
const TEST_STATUS_IDS = new Set(['testing', 'round_2', 'round_3', 'round_4', 'waiting']);

export function leadStatusToKindLabel(statusId) {
  return TEST_STATUS_IDS.has(statusId) ? 'Тестовый' : 'По амбассадору';
}
